/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} GermanInputs */

const de_german = /** @type {(inputs: GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

/** @type {(inputs: GermanInputs) => LocalizedString} */
const en_german = () => /** @type {LocalizedString} */ ('german')

/**

* @param {GermanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const german = /** @type {((inputs?: GermanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<GermanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_german(inputs)
	return en_german(inputs)
});